import { Alert, Box, Button, ButtonGroup, Stack, Typography } from "@mui/material";
import TimeUtil from "../TimeUtil";
import SetDestinationButton from "../SetDestinationButton";
import { CheckCircle, Warning } from "@mui/icons-material";
import TravelControl from "../TravelControl";
import { useDrawer } from "../context/DrawerContext";
import Settings from '../Settings';

function toMiles(mv, precission = 0) {
  if (!mv) {
    return null
  }

  var miles = 0.0;
  if (mv.unit === 'mile') {
    miles = mv.value;
  } else if (mv.unit === 'kilometer') {
    // Convert kilometers to miles (1 kilometer = 0.621371 miles)
    miles = mv.value * 0.621371;
  } else if (mv.unit === 'meter') {
    // Convert meters to miles (1 meter = 0.000621371 miles)
    miles = mv.value * 0.000621371;
  }
  return (miles).toFixed(precission);
}

function ArrivalInfo({ travel }) {
  if (!travel) {
    return null
  }

  // Convert meters to miles (1 meter = 0.000621371 miles)
  const distanceInMiles = toMiles(travel?.remainingDistance);

  // Format predicted arrival time
  let arrivalTime = 'N/A';
  try {
    if (travel?.predictedArrival) {
      const predictedArrivalDate = new Date(travel.predictedArrival);
      // Format to "h:mm a" (e.g., "2:30 PM")
      arrivalTime = TimeUtil.time(predictedArrivalDate);
    }
  } catch (error) {
    console.error("Error formatting arrival time:", error);
    // Keep arrivalTime as 'N/A' if formatting fails
  }

  return (
    <Box sx={{ textAlign: 'left' }}>
      {travel.destination && (
        <Typography variant="h5" className="font-bold">
          Drive to {travel?.destination?.locality}
        </Typography>
      )}
      <Typography variant="h6" className="font-extrabold">
        {distanceInMiles} miles
      </Typography>

      <Typography variant="h6" className="font-bold">
        {arrivalTime}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1}>
        {travel.onRoute ? (
          <>
            <CheckCircle color="success" />
            <Typography variant="body1" color="text.primary">
              On Route
            </Typography>
          </>
        ) : (
          <>
            <Warning color="warning" />
            <Typography variant="body1" color="text.primary">
              Off Route
            </Typography>
          </>
        )}
        <Box sx={{ ml: 2, borderLeft: '1px solid #ccc', pl: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Offset: {toMiles(travel.routeDistance, 1)} miles
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
}

function TravelInfo({ activeState, account, client }) {
  const {openDrawer} = useDrawer();

  const travel = activeState?.travel
  var hasRoute = travel;

  return (
    <Stack direction='column' spacing={2} >
      <Box>
        <ButtonGroup variant="contained">
          <SetDestinationButton
            currentLocation={activeState?.location}
            label="Start"
            disabled={hasRoute}
            redirect={false}
            account={account}
            client={client} />
          <TravelControl disabled={!hasRoute} status='IN_PROGRESS' id={travel?.id} client={client} onComplete={() => { }} onError={error => console.error('Error completing travel:', error)} />
          <Button disabled={!account} variant='contained' onClick={() => openDrawer('drive')}>Plan</Button>
        </ButtonGroup>
        {hasRoute && (<ArrivalInfo travel={travel} />)}
      </Box>
      {!hasRoute && (<Typography variant="h6">Destination not set.</Typography>)}
      {(!Settings.isTelemetryEnabled() || !Settings.isGpsEnabled()) && (
        <Alert severity="warning">Enable GPS and Telmetry in App settings <Button onClick={() => openDrawer('account')}>Go</Button></Alert>
      )}
    </Stack>
  );
}

export default TravelInfo; 